import { Bar } from "react-chartjs-2";
import { Panel } from "../../../components/panels/Panel";
import { useGetData } from "../../../services/api/api-tools";
import { Loader } from "../../../components/loading/Loader";
import { useEffect, useMemo, useState } from "react";
import { getInfluxdbData } from "../../../services/api/influxdb-tools";

export const ConstructionDashboardVideosCount = () => {

  const records = useGetData('records', 'records');
  const [filmingHours, setFilmingHours] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const fullQuery = `
        from(bucket: "engine")
        |> range(start: -100y)
        |> filter(fn: (r) => r["_measurement"] == "battery_information")
        |> filter(fn: (r) => r["_field"] == "battery_percentage")
        |> filter(fn: (r) => r["client_id"] == "${process.env.REACT_APP_CUSTOMER_NAME}_1")
        |> filter(fn: (r) => r["battery"] == "0")
        |> aggregateWindow(every: 30m, fn: count, createEmpty: false)
        |> aggregateWindow(every: 1mo, fn: count, createEmpty: false)
        |> map(fn: (r) => ({ r with _value: float(v: r._value) * 0.5 }))
        |> yield(name: "monthly_uptime")
      `;

      let filmingHoursData = await getInfluxdbData(
        'engine',
        null,
        [],
        [],
        null,
        null,
        null,
        null,
        null,
        [],
        null,
        fullQuery,
        false,
        null,
      );
      setFilmingHours(filmingHoursData);
    };

    getData();
  }, []);

  const now = new Date();

  const buildMonthlyVideoStats = (records) => {
    const now = new Date();

    const months = Array.from({ length: 12 }, (_, i) => {
      const date = new Date(now.getFullYear(), now.getMonth() - (11 - i), 1);

      return {
        year: date.getFullYear(),
        month: date.getMonth(),
        total: 0,
        favorites: 0
      };
    });

    records.forEach((record) => {
      const recordDate = new Date(record.date * 1000);
      const monthData = months.find(
        ({ year, month }) =>
          year === recordDate.getFullYear() &&
          month === recordDate.getMonth()
      );

      if (!monthData) return;

      monthData.total += 1;

      if (record.is_favorite === true) {
        monthData.favorites += 1;
      }
    });

    return months.map(({ total, favorites }) => [total, favorites]);
  };

  const buildMonthlyDataset = (values) => {
    const trimmedValues = values.slice(-12);

    const paddedValues = [
      ...Array.from(
        { length: Math.max(0, 12 - trimmedValues.length) },
        () => [0, 0]
      ),
      ...trimmedValues
    ];

    return {
      videosCount: paddedValues.map(([videosCount]) => videosCount),
      favoritesCount: paddedValues.map(([, favoritesCount]) => favoritesCount)
    };
  };

  const labels = Array.from({ length: 12 }, (_, i) => {
    const date = new Date(now.getFullYear(), now.getMonth() - (11 - i), 1);

    return date.toLocaleDateString('fr-FR', {
      month: 'short',
      year: '2-digit'
    });
  });

  const monthlyStats = useMemo(() => {
    const safeRecords = records.isLoading ? [] : (records.data ?? []);
    return buildMonthlyVideoStats(safeRecords);
  }, [records.isLoading, records.data]);

  const buildLineValues = (data) => {
    const values = data.map(({ _value }) => _value);

    return [
      ...Array.from(
        { length: Math.max(0, 12 - values.length) },
        () => 0
      ),
      ...values.slice(-12)
    ];
  };

  const { videosCount, favoritesCount } = buildMonthlyDataset(monthlyStats);
  const lineValues = buildLineValues(filmingHours);

  const data = {
    labels,
    datasets: [
      {
        type: 'bar',
        order: 0,
        label: 'Alertes remontées',
        data: videosCount,
        backgroundColor: '#4164FD',
        categoryPercentage: 0.6,
        barPercentage: 0.7,
        borderRadius: 6,
      },
      {
        type: 'bar',
        order: 0,
        label: 'Alertes sélectionnées',
        data: favoritesCount,
        backgroundColor: '#2CEAA8',
        categoryPercentage: 0.6,
        barPercentage: 0.7,
        borderRadius: 6,
      },
      {
        type: 'line',
        order: 1,
        label: 'Durée de captation (heures)',
        data: lineValues,
        borderColor: '#777777',
        backgroundColor: 'rgba(119, 119, 119, 0.2)',
        fill: true,
        tension: 0.35,
        pointRadius: 3,
        pointHoverRadius: 5,
        yAxisID: 'y1'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top'
      }
    },
    scales: {
      x: {
        stacked: false,
        grid: {
          display: false
        }
      },
      y: {
        type: 'linear',
        position: 'left',
        beginAtZero: true,
        ticks: {
          color: '#4164FD'
        },
        grid: {
          color: 'rgba(65, 100, 253, 0.08)'
        },
        title: {
          display: true,
          text: 'Alertes',
          color: '#4164FD'
        }
      },
      y1: {
        type: 'linear',
        position: 'right',
        beginAtZero: true,
        ticks: {
          color: '#777777'
        },
        grid: {
          drawOnChartArea: false
        },
        title: {
          display: true,
          text: 'Heures',
          color: '#777777'
        }
      }
    }
  };

  return (
    <Panel noHeader={true} rounded={true} category="secondary" width="w-3/4">
      {records.isLoading ?
        <Loader category="transparent"/> :
        <Bar data={data} options={options} />
      }
    </Panel>
  );
};